import './request-section.scss';

export default () => {
	if ( $( '.request-section' ).length ) {
		$( '.header' ).addClass( 'header--transparent' );
	}
};
